import { builderAutomaticSizeConfigValues } from '~/shared/constants/productSizes';
import { getProfileSizeFiltersToApply } from '~/shared/utils/getProfileSizeFiltersToApply';
import { getSizesWithNeighbors } from '~/shared/utils/getSizesWithNeighbors';
import { combineExpandedPlusSizes } from '~/shared/utils/plusSizeFilters';

export default function getAutoAppliedInitialFilters({
  initialFilters,
  profileSizes,
  shouldApplyProfileSizes = true,
  automaticSizeConfig = {},
}) {
  let autoAppliedFilters = null;

  if (profileSizes && shouldApplyProfileSizes) {
    // We want to combine XXL, XXL-1X, 1X filters, into just XXL-1X
    // (Only for Fabletics, not Savage)
    const parsedProfileSizes = combineExpandedPlusSizes(profileSizes);
    autoAppliedFilters = getProfileSizeFiltersToApply(
      parsedProfileSizes,
      initialFilters
    );

    if (
      autoAppliedFilters &&
      automaticSizeConfig?.customerGender &&
      automaticSizeConfig?.builderAutomaticSizeFiltering ===
        builderAutomaticSizeConfigValues.PROFILE_SIZE_WITH_UP_DOWN
    ) {
      const result = {};
      Object.keys(autoAppliedFilters).forEach((key) => {
        const size = autoAppliedFilters[key][0];
        result[key] = getSizesWithNeighbors({
          size,
          gender: automaticSizeConfig.customerGender,
        });
      });
      autoAppliedFilters = result;
    }

    return {
      autoAppliedFilters,
      initialFilters: autoAppliedFilters
        ? {
            ...initialFilters,
            aggregationFilter: {
              ...initialFilters.aggregationFilter,
              ...autoAppliedFilters,
            },
          }
        : initialFilters,
    };
  }

  return {
    autoAppliedFilters,
    initialFilters,
  };
}
